/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";

export async function fetchUniversityGalleryByCountry(
  country: string | undefined,
  setState: (images: string[]) => void,
) {
  if (!country) return;

  try {
    const formattedCountry = country
      .replace("europe -", "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace("united_states_of_america", "united_states");

    const response = await axios.get(
      `https://storage.googleapis.com/storage/v1/b/edvia_public_bucket/o?prefix=universities1/${formattedCountry}/gallery`,
    );

    const images = response.data.items
      .filter((item: any) => item.name.match(/\.(webp|jpg|jpeg|png|svg)$/))
      .map((item: any) => {
        return `https://storage.googleapis.com/edvia_public_bucket/${item.name}`;
      });
    setState(images);
  } catch (error) {
    console.error("Error fetching university gallery:", error);
  }
}

export const tableRows = [
  ["Scale", "4.0 (or 5.0)", "10.0 (most common)"],
  ["Usage", "USA, Canada, Australia", "India, Middle East, parts of Asia"],
  ["Calculation", "Credit-weighted average", "Simple or weighted average"],
  [
    "Scope",
    "Can be per semester or cumulative",
    "Cumulative across all semesters",
  ],
];

export const challenges = [
  [
    "Different Grading Scales",
    "Not all institutions use a 10-point CGPA scale. Some use 4, 5, or 7-point scales.",
    "Always identify your institution's maximum scale first, then apply the proportional conversion formula accordingly.",
  ],
  [
    "Inconsistent Conversion Methods",
    "Different universities and evaluation services may use different conversion formulas.",
    "Use the conversion method specified by your target university or opt for official credential evaluation services for standardized results.",
  ],
  [
    "Credit Weighting Differences",
    "CGPA may be calculated differently (credit-weighted vs simple average) than GPA systems expect.",
    "Provide detailed transcripts showing credit hours and individual course grades for accurate evaluation by admission committees.",
  ],
  [
    "Rounding & Precision Issues",
    "Questions about whether to round up or maintain decimal precision in conversions.",
    "Maintain two decimal places for accuracy. Most universities accept GPA values like 3.45 or 3.78.",
  ],
  [
    "Country-Specific Requirements",
    "Different countries have unique grading systems and conversion expectations (German scale, UK classification, etc.).",
    "Research specific country requirements. Germany may need modified Bavarian formula; UK may prefer class divisions over GPA.",
  ],
  [
    "Lack of Official Documentation",
    "Some universities don't provide official conversion formulas on transcripts.",
    "Request an official statement from your university's academic office or consider using recognized third-party evaluation services.",
  ],
  [
    "Grade Inflation Concerns",
    "Some admissions committees may perceive direct conversions as not reflecting true academic rigor.",
    "Provide context such as class rank, percentile, or university grading distribution when possible.",
  ],
];
